export default __webpack_public_path__ + "static/LogoHeader-5c87aca2b58564b9e11b1544f3e72886.svg";